import React from 'react';
import blurTopImage from '../assets/blur-top.png';
import './AppLayout.css';

const AppLayout = ({ children }) => {
  return (
    <div className="app-layout">
      <div className="blur-top">
        <img src={blurTopImage} alt="Blur effect" className="blur-image" />
      </div>
      <div className="app-content">{children}</div>
    </div>
  );
};

export default AppLayout;
